import React, { useState, useRef, useMemo, useEffect } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./GridMaster.css";
import {
  defaultColParas,
  formatDateInDDMMYYYY,
} from "../../functions/common-functions";
import { useSelector } from "react-redux";
import {
  resetFilter,
  resetAllFilter,
  FilterChange,
  getData,
} from "../../functions/common-functions";
import { BsX } from "react-icons/bs";
import { Container, Button, Card, Row, Col } from "react-bootstrap";
import ActionRenderer from "./ActionRenderer";
import StatusRenderer from "./StatusRenderer";
import Pagination from "../utils/Pagination";
import axios from "axios";

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Set a timer to update the debounced value after the delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Clean up the timer if the value changes before the delay is over
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const GridMasterInfiniteMode = (props) => {
  const [gridApi, setGridApi] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredCol, setFilteredCol] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [data, setData] = useState(props.rowDetails);
  const searchReText = useSelector((state) => state.grid.searchQuery);
  const gridRef = useRef();
  // const [pageSize] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = 7;
  const dataFetchLimit = 100;
  const lastKeyRef = useRef(null);
  // const gridRef = useRef(null);
  const API_URL = process.env.REACT_APP_API_URL;

  // const [globalSearch, setGlobalSearch] = useState("");
  // Use the hook here
  const debouncedSearch = useDebounce(searchReText, 500);

  // const getRowId = useMemo(() => {
  //   return (params) => params.data.RoleCode;
  // }, []);
  let tmpvar = {};
  let actionDisplay = false;
  if (props.hasOwnProperty("actionName")) {
    actionDisplay = true;
    tmpvar = props.actionName;
  }

  let pagination = true;
  if (props.hasOwnProperty("pagination")) {
    pagination = props.pagination;
  }
  let hideActionBtns = props.hasOwnProperty("noActionButtons")
    ? props.noActionButtons
    : false;

  useEffect(() => {
    // console.log("props.rowDetails",props.rowDetails)
    setData(props.rowDetails);
  }, [props.rowDetails]);

  const defaultColDef = useMemo(() => {
    return {
      ...defaultColParas(),
      getQuickFilterText: (params) => {
        let value = params.value;
        if (value === null || value === undefined) return "";

        // Convert to string
        let searchText = value.toString();

        // If it's a date field, also include formatted version
        const fieldName = params.colDef.field;
        if (
          fieldName &&
          (fieldName.toLowerCase().includes("date") ||
            fieldName === "DueDate" ||
            fieldName === "InsertedOn" ||
            fieldName === "ModifiedOn")
        ) {
          try {
            const formattedDate = formatDateInDDMMYYYY(value.toString());
            if (formattedDate && formattedDate !== value.toString()) {
              searchText += " " + formattedDate;
            }
          } catch (e) {
            // If formatting fails, use original value
          }
        }

        return searchText;
      },
    };
  }, []);

  // 1. Move dataSource logic into a separate function/useCallback
  const createDataSource = (searchQuery) => ({
    getRows: async (getRowParams) => {
      // Show overlay if this is the first load or a slow search
      gridApi?.showLoadingOverlay();
      try {
        if (getRowParams.startRow === 0) {
          lastKeyRef.current = null;
        }

        let allFetchedItems = [];

        let currentLastKey = lastKeyRef.current;
        let scanCount = 0;
        const MAX_SCANS = 10; // Safety break to prevent infinite loops

        console.log(
          "allFetchedItems length Before Loop :: ",
          allFetchedItems.length,
          "\t scanCount :: ",
          scanCount,
          "\t MAX_SCANS :: ",
          MAX_SCANS,
          "\t debouncedSearch :: ",
          debouncedSearch,
          "\n",
          allFetchedItems,
        );
        // Keep fetching until we find some items OR hit the end OR hit safety limit
        while (allFetchedItems.length < pageSize) {
          const apiParams = {
            limit: pageSize,
            lastEvaluatedKey: currentLastKey || "",
            filterModel: getRowParams.filterModel,
            globalSearch: debouncedSearch, // Pass global search to API
          };

          const response = await props.getData(apiParams);
          // const response = await axios.post(
          //   `${API_URL}/customermaster/getactivecustomers`,
          //   apiParams,
          // );
          console.log("Inside response calling func :: ", response);
          const newItems = response.data.items || [];
          allFetchedItems = [...allFetchedItems, ...newItems]; // ACCUMULATE, don't replace
          currentLastKey = response.data.lastEvaluatedKey;
          scanCount++;
          console.log(
            "scanCount :: ",
            scanCount,
            "\t currentLastKey :: ",
            currentLastKey,
            "\t allFetchedItems.length :: ",
            allFetchedItems.length,
          );
          // If no more data in DynamoDB, stop searching
          if (!currentLastKey) break;
        }

        // Update the ref for the NEXT time AG Grid calls getRows
        lastKeyRef.current = currentLastKey;
        console.log(
          "getRowParams.startRow :: ",
          getRowParams.startRow,
          "\nallFetchedItems length :: ",
          allFetchedItems.length,
          "\n",
          allFetchedItems,
        );
        gridApi?.hideOverlay(); // Hide once data is ready
        // If we found NO items and there is NO more data, it's truly the end.
        // If we have items or more data, tell AG Grid to keep the scroll active.
        let lastRow = -1;
        if (!currentLastKey && allFetchedItems.length < pageSize) {
          lastRow = getRowParams.startRow + allFetchedItems.length;
        }
        console.log("lastRow :: ", lastRow);
        getRowParams.successCallback(allFetchedItems, lastRow);
      } catch (error) {
        getRowParams.failCallback();
      }
    },
  });

  const onGridReady = (params) => {
    setGridApi(params.api);
    const dataSource = createDataSource(debouncedSearch);
    console.log("dataSource :: ", dataSource);
    params.api.setDatasource(dataSource);
  };

  // 3. Updated useEffect
  useEffect(() => {
    if (gridApi) {
      console.log("Global search triggered for:", debouncedSearch);
      lastKeyRef.current = null;

      // Create a NEW datasource with the NEW search query
      const newDataSource = createDataSource(debouncedSearch);

      // Refresh grid using the correct API method
      // gridApi.setGridOption("datasource", newDataSource);
      gridApi.setDatasource(newDataSource);
    }
  }, [debouncedSearch, gridApi]);

  const onSelectionChanged = (params) => {
    const selected = params.api.getSelectedRows();
    setSelectedRows(selected);
    if (props.onSelectionChanged) {
      props.onSelectionChanged(selected);
    }
  };

  // const filteredResult = useMemo(() => {
  //   let firstPageIndex = 0;
  //   if (currentPage > 1) {
  //     firstPageIndex = (currentPage - 1) * pageSize;
  //   }
  //   if (firstPageIndex >= data.length) {
  //     firstPageIndex = 0;
  //     const totalPageCount = Math.ceil(data.length / pageSize);
  //     if (totalPageCount > 0) {
  //       setCurrentPage(totalPageCount);
  //     } else {
  //       setCurrentPage(1);
  //     }
  //   }
  //   let lastPageIndex = parseInt(firstPageIndex) + parseInt(pageSize);
  //   return data ? data.slice(firstPageIndex, lastPageIndex) : [];
  // }, [currentPage, data, pageSize]);

  // useEffect(() => {
  //   setData(props.rowDetails);
  //   if (gridRef.current && gridRef.current.api) {
  //     gridRef.current.api.setQuickFilter(searchReText);
  //     let temp = getData(gridRef.current.api);
  //     props.setExcelData(temp);
  //     setData(temp);
  //     if (props.onFilteredDataChange) {
  //       props.onFilteredDataChange(temp);
  //     }
  //   }
  // }, [gridRef.current, searchReText]);

  useEffect(() => {
    if (gridRef.current.api) resetAllFilter(gridRef);
  }, [props.resetind]);

  // useEffect(() => {
  //   if (filteredCol.length > 0) {
  //     props.getDataEvent(rowData);
  //   }
  // }, [filteredCol, rowData]);

  return (
    <Container fluid className="grid-comp-container">
      <div className="d-none">
        {props.getFilterColLength(filteredCol.length)}
      </div>
      {filteredCol.length > 0 && (
        <div className="filterList">
          {filteredCol.map((item, index) => {
            return (
              <div
                key={`FilterCol${index}`}
                className="filter-col pr-0 me-2 mb-2"
              >
                <span className="ps-2 btn-text">{item}</span>
                <div
                  onClick={() => resetFilter(gridRef, item, props.fieldNames)}
                >
                  <BsX size={25} />
                </div>
              </div>
            );
          })}
          <div>
            <Button
              variant="outline-primary"
              className="ms-2 lh-1 clear-all-btn"
              style={{ marginTop: "2%" }}
              onClick={() => {
                resetAllFilter(gridRef);
              }}
            >
              Clear All
            </Button>
          </div>
        </div>
      )}

      <div className="ag-theme-alpine agGridContainer d-none d-md-block d-lg-block">
        <AgGridReact
          ref={gridRef}
          // columnDefs={columnDefs}
          rowModelType="infinite" // Critical for large datasets
          cacheBlockSize={pageSize} // How many rows to fetch per request
          // onGridReady={onGridReady}
          // pagination={true}
          paginationPageSize={pageSize} // e.g., 100
          // rowHeight={40}
          // headerHeight={40}
          // rowSelection={"multiple"}
          // enableBrowserTooltips={true}
          // domLayout="autoHeight"
          rowData={props.rowDetails}
          columnDefs={props.colDetails}
          defaultColDef={defaultColDef}
          getRowId={props.getRowId}
          rowHeight={40}
          headerHeight={40}
          onGridReady={onGridReady}
          pagination={pagination}
          rowSelection={props.rowSelection || "multiple"}
          enableBrowserTooltips={true}
          getRowStyle={props.getRowStyle}
          onSelectionChanged={onSelectionChanged}
          suppressRowClickSelection={props.suppressRowClickSelection}
          domLayout="autoHeight"
          animateRows={false}
        />
      </div>
    </Container>
  );
};
export default GridMasterInfiniteMode;
